var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "badge",
      class: _vm.badgeType,
      style: { height: _vm.height + "px", width: _vm.width + "px" },
    },
    [
      _c("div", { staticClass: "main-body" }, [_vm._t("main")], 2),
      _c("div", { staticClass: "type-body" }, [_vm._t("type")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }